import { Status } from "./Status";

export class FoundStatusSmartEnum {
    static Undecided = new Status("Undecided", 1, "pill--blue");
    static NotFound = new Status("Not Found", 2, "pill-red", "NotFound");
    static Confirmed = new Status("Confirmed", 3, "pill--green");

    public static getName() {
        // Cannot use this.name as it will be the minified value in production
        return "FoundStatusSmartEnum";
    }
}
